export const isAgentUser = (user) => {
  if (!user) return false;
  return (
    user.isAgent === true ||
    user.isConciergeAgent === true ||
    user.isDefaultConcierge === true
  );
};

export const isConciergeUser = isAgentUser;
